import { isNullOrUndefined } from "@shoothill/core";
import { action, computed, observable } from "mobx";
import { ApprovalListViewModel } from "../ApprovalListViewModel";
import { ApprovalSignalRViewModel } from "../ApprovalSignalR/ApprovalSignalRViewModel";
import { PurchaseListViewModel } from "../PurchaseListViewModel";

export class TabItemViewModel {
    public constructor(id: string, title: string) {
        this.id = id;
        this.title = title;
    }

    @observable
    public id: string = "";

    @observable
    public title: string = "";

    @observable
    public isActive: boolean = false;

    @computed
    public get canDisplayCount() {
        return !isNullOrUndefined(this.count) && this.count! > 0;
    }

    @computed
    public get count() {
        switch (this.id) {
            case ApprovalListViewModel.TAB_REQUIRED_APPROVALS:
                return ApprovalSignalRViewModel.Instance.getRequiredCount;
            case PurchaseListViewModel.TAB_AMENDS_REQUIRED:
                return ApprovalSignalRViewModel.Instance.getAmendCount;
            default:
                return undefined;
        }
    }
}
